import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import { useMediaQuery } from "_common/component/MediaQueryProvider";
import ContractMobile from "./Mobile";
import ContractDesktop from "./Desktop";

const ContractPage = observer(() => {
  const { isMobile } = useMediaQuery();

  if (isMobile) return <ContractMobile />;
  return <ContractDesktop />;
});

export default ContractPage;
